<template>
	<div class="">
		<div class="zhuanye-intro">
			<div class="intro1">
				<div class="intro1-tit">
					<div class="wl"></div>
					<span>经济学主要课程</span>
				</div>
				<div class="nr">
					<span>
						政治经济学、《资本论》、西方经济学、统计学、国际经济学、货币银行学、财政学、经济学说史、发展经济学、企业管理、市场营销、国际金融、
						国际贸易、线性代数、高等数学、概率论与数理统计等
					</span>
				</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>

	export default {
		name: "",
		components: {
			
		},
		data() {
			return {}
		},
		methods: {
			
		}


	}
</script>

<style scoped>
	.zhanwei {
		width: 100%;
		height: 46px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.zhanwei li{
		width: 25%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: -3px -1px 18px rgb(6 0 1 / 41%);
		cursor: pointer;
	}
	.zhanwei1{
		background: #F53824;
	}
	.zhanwei1 span{
		background: #F53824;
		color: #FFFFFF;
	}
	.zhanwei2 span{
		color: #333333;
	}
	
	.zhanwei li span{
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		
	}
	.zhanwei li img{
		height: 18px;
		margin-right: 10px;
	}
	.container{
		width: 73%;
	}
	.intro1{
		margin-bottom: 20px;
	}
	.intro2{
		margin-bottom: 20px;
	}
	.intro3{
		margin-bottom: 20px;
	}
	.nr span {
		font-size: 16px;
		font-weight: 500;
		color: #666666;
		opacity: 1;
		
	}
	
	.nr {
		display: block;
		padding-left: 20px;
		box-sizing: border-box;
	}
	
	.zhuanye-intro {
		line-height: 35px;
		display: block;
		min-height: 372px;
	}
	
	.intro3-tit span {
		margin-left: 5px;
		font-size: 20px;
		font-weight: 500;
		color: #333333;
		opacity: 1;
		margin-top: -8px;
	
	}
	.intro2-tit{
		margin-bottom: 15px;
	}
	.intro2-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	
	}
	.intro1-tit{
		margin-bottom: 15px;
	}
	.intro1-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	}
	
	.wl {
		width: 6px;
		height: 22px;
		border-radius: 0px 4px 4px 0px;
		background: #F21323;
	}
	
	.intro1-tit {
		display: flex;
	}
	
	.intro2-tit {
		display: flex;
	}
	
	.intro3-tit {
		display: flex;
	}
	
	
	.top-btn{
		display: flex;
	}
	.top-btn button {
		width: 76px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgb(241, 241, 241);
		opacity: 1;
		border-radius: 21px;
		border: none;
		color: #666666;
	}
	.top-btn button:nth-of-type(1){
		margin-right: 15px;
	}
	.left-bottom{
		margin-top: 20px;
	}
	.left-bottom span{
		margin-right: 15px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
	}
	.left-bottom span:nth-of-type(3){
		margin-right: 0;
	}
	.left-bottom span:nth-of-type(3) label{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}
	.shoucang span img {
		margin-left: 5px;
	}
	
	.shoucang span {
		width: 80px;
		height: 34px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(134deg, #3EC2FF 0%, #29A7E1 100%);
		opacity: 1;
		border-radius: 21px;
		color: white;
		padding: 0px 5px 0 5px;
	}
	
	.shoucang {
		margin-left: 10px;
	}
	
	a {
		color: #29A7E1;
		text-decoration: none;
	}
	
	.top-right {
		line-height: 41px;
		display: block;
		margin-left: 14px;
	}
	
	.left-top {
		display: flex;
	}
	
	.toubu-right {
		line-height: 30px;
		display: block;
		margin-left: 40px;
		margin-top: 33px;
	}
	
	.toubu-left {
		display: block;
		flex-shrink: 0;
	}
	.right-top span{
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}
	.right-bottom a{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}
	.toubu_top{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-around;
		padding: 30px 30px 0 30px;
		box-sizing: border-box;
	}
	.toubu {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 226px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
		opacity: 1;
		border-radius: 5px 5px 0 0;
		margin-top: 20px;
		margin-bottom: 40px;
	}
	@media (max-width:750px) {
		.toubu{
			display: block;
		}
		.toubu-right{
			margin: 0;
		}
		.shoucang{
			text-align: right;
		}
		.container{
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/information/majorinfo/kechengshezhi.vue